export { PartnersCard } from './partners-card'
